import styled from "styled-components";
import { up } from "../lib/styles";

const TextList = styled.ul`
  font-size: 22px;
  color: ${({ black }) => (black ? "#000" : "#8d8d8f")};
  padding-left: 20px;
  list-style: disc;
  margin-top: 8px;
  margin-bottom: 32px;
  li {
    line-height: 1.8;
  }

  ${up("tablet")} {
    padding-left: 48px;
  }
`;

export const OrderedTextList = styled.ol`
  font-size: 22px;
  color: ${({ black }) => (black ? "#000" : "#8d8d8f")};
  padding-left: 20px;
  margin-top: 12px;
  margin-bottom: 8px;
  li {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${up("tablet")} {
    padding-left: 48px;
  }
`;

export default TextList;